import moment from 'moment';
import Meal from './schema/Meal';
import Bottle from './schema/Bottle';
import Mood from './schema/Mood';
import Nap from './schema/Nap';
import Bathroom from './schema/Bathroom';
import Incident from './schema/Incident';
import Photo from './schema/Photo';
import Video from './schema/Video';
import Absent from './schema/Absent';
import Learning from './schema/Learning';
import NameToFace from './schema/NameToFace';
import Observation from './schema/Observation';
import Default from './schema/Default';
import { ACTIVITY_TYPES } from 'constants/activityTypes';

const ActivitySchema = {
  meal_activity: Meal,
  bottle_activity: Bottle,
  mood_activity: Mood,
  nap_activity: Nap,
  bathroom_activity: Bathroom,
  incident_activity: Incident,
  photo_activity: Photo,
  video_activity: Video,
  medication_activity: Default,
  note_activity: Default,
  absent_activity: Absent,
  learning_activity: Learning,
  name_to_face_activity: NameToFace,
  observation_activity: Observation
};

const isPhotoOrVideoActivity = type => type === ACTIVITY_TYPES.photoActivity || type === ACTIVITY_TYPES.videoActivity;

const buildActivityPayload = (type, params) => {
  if (!type) {
    return null;
  }

  if (params.data.flag) {
    let payload = ActivitySchema[type](params.data, params.daily_activity || params.activity, params.isEditing);
    const activityDate = moment(
      (params.daily_activity ? params.daily_activity.activity_date : params.data.date) || undefined
    ).format('YYYY-MM-DD');

    const newActivityPayload = {
      ...payload,
      activity: {
        ...(payload.daily_activity || {}),
        approval_status: payload.daily_activity.is_staff_only ? 'pending' : 'approved',
        ...(isPhotoOrVideoActivity(type) ? { comment: params.data.caption || '' } : {})
      },
      daily_activity: undefined,
      activiable: {
        incident: payload.incident,
        learnings: payload.learning,
        ...(type === ACTIVITY_TYPES.photoActivity ? { photo: params?.activity?.activiable } : {}),
        ...(type === ACTIVITY_TYPES.videoActivity
          ? { video: { ...params?.activity?.activiable, caption: params.data.caption } }
          : {}),
        observations:
          payload.daily_activity.measure_ids === undefined && payload.daily_activity.indicator_ids === undefined
            ? undefined
            : {
                measure_ids: payload.daily_activity.measure_ids,
                indicator_ids: payload.daily_activity.indicator_ids
              }
      },
      teacher_ids: [params.data.staff_present],
      filters: { activity_date: activityDate },
      lookup_activity_date: activityDate
    };

    return newActivityPayload;
  } else {
    const payload = ActivitySchema[type](params.data, params.activity, params.isEditing);
    const activityDate = moment(
      (params.activity ? params.activity.activity_date : params.data.date) || undefined
    ).format('YYYY-MM-DD');

    const exendedWithStaffPresentField = {
      ...payload,
      daily_activity: {
        ...(payload.daily_activity || {}),
        staff_present_id: params.data.staff_present || null,
        ...(isPhotoOrVideoActivity(type) ? { comment: params.data.caption || '' } : {})
      },
      filters: { activity_date: activityDate },
      lookup_activity_date: activityDate
    };

    return exendedWithStaffPresentField;
  }
};

export default buildActivityPayload;
